import styles from './Error.module.css'

export const Error = ({msg}) => {
    return (
      <p className={styles.error}>{msg}</p>
    )
}
